import Banner from '../components/Banner';
import PropertyInfoForm from '../components/PropertyInfoForm';
import DollarLogo from '../assets/images/banner-logo-dollar.svg';

const Home = () => {
  return (
    <div>
      <Banner bannerImage={DollarLogo} />
      <div className="stepper-form-container">
        <PropertyInfoForm />
      </div>
    </div>
  );
};

export default Home;
